import { createReducer, INITIAL_STATE } from '@shared/redux';

export const SET_MANAGER_REPORT_PARAMS = '@dashboard-manager/SET_MANAGER_REPORT_PARAMS';

export const getManagerReportNameParams = (state, reportName) => state?.dashboard
    ?.dashboardManager?.[reportName];

export const setDomainManagerParams = ({ params, reportName }) => ({
    type: SET_MANAGER_REPORT_PARAMS,
    payload: {
        reportName,
        params,
    },
});

export const dashboardManagerReducer = createReducer({
    [INITIAL_STATE]: {},
    [SET_MANAGER_REPORT_PARAMS]: (state, action) => ({
        ...state,
        [action.payload.reportName]: {
            ...action.payload.params,
        },
    }),
});
